module.exports = require('./helpers/bundle-url').getBundleURL('fVM3f') + "logo-dark.eefe0b7f.svg";